<template>
    <v-container>

        <!--------------------------------------->
        <!--           Week Selector           -->
        <!--------------------------------------->
        <v-row
            justify="center"
            no-gutters
        >
            <h5>
                {{weekDescription}}
            </h5>
        </v-row>
        <v-row
            no-gutters
        >
            <v-col
                class="text-center"
            >
                <v-btn
                    x-small
                    fab
                    class="mx-3"
                    color="grey darken-4"
                    :disabled="minWeek"
                    @click.prevent="subtractWeek"
                >
                    <v-icon color="white">
                        keyboard_arrow_left
                    </v-icon>
                </v-btn>
                {{weekStart | moment("MM/DD/YYYY")}}
                - 
                {{weekEnd | moment("MM/DD/YYYY")}}
                <v-btn
                    x-small
                    fab
                    class="mx-3"
                    color="grey darken-4"
                    :disabled="maxWeek"
                    @click.prevent="addWeek"
                >
                    <v-icon color="white">
                        keyboard_arrow_right
                    </v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <!--------------------------------------->
        <!--       Approval Instructions       -->
        <!--------------------------------------->
        <v-row
            v-if="!savedMenu"
        >
            <v-col class="text-center red--text">
                <h4>
                    Review the menu below. Make edits as needed. Save at the bottom when ready.
                </h4>
            </v-col>
        </v-row>

        <!--------------------------------------->
        <!--  Initialize Recipe Pop-up Dialog  -->
        <!--------------------------------------->
        <v-dialog
            v-model="recipeDialog"
            fullscreen
            hide-overlay
            style="overflow-x: hidden"
        >
            <template
                v-slot:activator="{ on }"
            >

        <!--------------------------------------->
        <!--         Day Card Iterator         -->
        <!--------------------------------------->
                <v-row
                    my-3
                    py-5
                >
                    <v-col>
                        <v-expansion-panels
                            v-model="day"
                            hover
                            popout
                            focusable
                        >
                            <v-expansion-panel
                                v-for="(day,d) in menu"
                                :key="d"
                            >

        <!--------------------------------------->
        <!--          Header Contents          -->
        <!--------------------------------------->
                                <v-expansion-panel-header
                                    v-if="d == today && savedMenu && weekOffset == 0"
                                    id = "today"
                                >
                                    <v-col>
                                        <v-row
                                            class="ml-1"
                                            align="center"
                                            justify="start"
                                        >
                                            <v-icon
                                                v-if="!savedMenu"
                                                color="blue"
                                                medium
                                                class="mr-1"
                                            >
                                                edit
                                            </v-icon>
                                            <v-icon
                                                v-else
                                                medium
                                                class="mr-2"
                                                color="blue"
                                            >
                                                today
                                            </v-icon>
                                            <h3
                                                style="color:#2196F3;"
                                            >
                                                {{moment().startOf('week').add(d+7*weekOffset,'day') | moment("M/D")}} {{ day.day }}
                                            </h3>
                                        </v-row>
                                    </v-col>
                                    
                                </v-expansion-panel-header>
                                <v-expansion-panel-header
                                    v-else
                                >
                                    <v-col>
                                        <v-row
                                            class="ml-2"
                                        >
                                            <v-icon
                                                v-if="!savedMenu"
                                                color="blue"
                                                medium
                                                class="mr-1"
                                            >
                                                edit
                                            </v-icon>
                                            <h3>{{moment().startOf('week').add(d+7*weekOffset,'day') | moment("M/D")}} {{ day.day }}</h3>
                                        </v-row>
                                    </v-col>
                                </v-expansion-panel-header>
        
        <!--------------------------------------->
        <!--        Expansion Contents         -->
        <!--------------------------------------->
                                <v-expansion-panel-content>
                                    <v-container flex class="pa-2 mt-3">
                                        <v-row>
                                            <v-col
                                                v-for="(detail,d) in day.details"
                                                :key="d"
                                                class = "text-center pa-0 ma-0"
                                                cols="6"
                                                xs="6"
                                                sm="4"
                                                md="4"
                                                lg="2"
                                                xl="2"
                                            >
                                                <v-card
                                                    class="ma-2 pa-4"
                                                    raised
                                                    @click.prevent="selectedRecipe(detail.mealName)"
                                                    v-on="on"
                                                >
                                                    <v-btn
                                                        v-if="!savedMenu"
                                                        absolute
                                                        dark
                                                        icon
                                                        small
                                                        color="blue"
                                                        style="top: 3px; right: 3px;"
                                                    >
                                                        <v-icon>edit</v-icon>
                                                    </v-btn>

                                                    <h4>{{detail.mealType}}</h4>
                                                    <v-img
                                                        :src="detail.mealImage"
                                                        center
                                                    />
                                                    <h5 class="text-no-wrap">{{detail.mealName}}</h5>
                                               
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                </v-row>
            </template>

        <!--------------------------------------->
        <!--   Recipe Pop-up Dialog Contents   -->
        <!--------------------------------------->
            <v-card
                style="overflow-x: hidden"
            >
                <v-toolbar
                    color="grey lighten-3"
                >
                    <v-row
                        justify="end"
                        align="center"
                    >                        
                        <v-btn
                            small
                            fab
                            @click="closeRecipe"
                            class="mr-3"
                        >
                            <v-icon>
                                close
                            </v-icon>
                        </v-btn>
                    </v-row>
                </v-toolbar>
                <v-row>
                    <v-col>
                        <Recipe/>
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>

        <!--------------------------------------->
        <!--         Below-Menu Options        -->
        <!--------------------------------------->
        <v-row
            align="center"
            class="mt-0 mx-7"
        >
        <!--     Save Menu     -->
            <v-col
                class="text-right mr-0 pr-0 mb-12"
            >
                <v-btn
                    v-if="!savedMenu"
                    color="blue"
                    class="white--text"
                    @click.prevent="updateSave"
                >
                    Save
                </v-btn>

        <!--  Shopping List  -->
                <v-dialog
                    v-if="savedMenu"
                    v-model="shoppingListDialog"
                    fullscreen
                    hide-overlay
                >
                    <template v-slot:activator="{ on }">
                        <v-btn
                            icon
                            x-large
                            @click.prevent="openShoppingList"
                            v-on="on"
                        >
                            <v-icon x-large color="grey darken-4">
                                shopping_cart
                            </v-icon>
                        </v-btn>
                    </template>

        <!--------------------------------------->
        <!--Shopping List Pop-up Dialog Content-->
        <!--------------------------------------->
                    <v-card>
                        <v-toolbar
                            color="grey lighten-3"
                        >
                            <v-row
                                justify="center"
                                align="center"
                            >
                                <h1>
                                    Shopping List
                                </h1>

                                <v-btn
                                    absolute
                                    small
                                    fab
                                    class="mr-3 text-right"
                                    style="top: 10px; right: 0px;"
                                    @click="closeShoppingList"
                                >
                                    <v-icon>
                                        close
                                    </v-icon>
                                </v-btn>
                                    
                            </v-row>
                        </v-toolbar>
                        <v-row>
                            <v-col>
                                <ShoppingList/>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
import Recipe from '@/components/menu/Recipe.vue'
import ShoppingList from '@/components/menu/ShoppingList.vue'
let moment = require('moment');

export default {

    components: {
        Recipe,
        ShoppingList
    },

    data: () => ({
        moment: moment,
        recipeDialog: false,
        shoppingListDialog: false,
    }),

    methods: {
        addWeek: function() {
            this.$store.dispatch('menu/addWeek');
            this.$store.dispatch('menu/day',[]);
        },
        subtractWeek: function() {
            this.$store.dispatch('menu/subtractWeek');
            this.$store.dispatch('menu/day',[]);
        },
        selectedRecipe: function(value) {
            this.recipeName = value;
            this.recipeDialog = true;
            this.$store.dispatch('menu/updateRecipeSize', null);
            this.$store.dispatch('menu/updateRecipeSizeUnits', null);
        },
        closeRecipe: function() {
            this.recipeDialog = false;
            this.$store.dispatch('menu/updateRecipeSize', null);
            this.$store.dispatch('menu/updateRecipeSizeUnits', null);
        },
        openShoppingList: function() {
            this.shoppingListDialog = true;
            this.$store.dispatch('menu/day',[]);
        },
        closeShoppingList: function() {
            this.shoppingListDialog = false;
            this.$store.dispatch('menu/day',[]);
        },
        updateSave: function() {
            this.$store.dispatch('menu/savedMenu');
            this.$store.dispatch('menu/day',[])
        },
    },

    computed: {
        weekStart() {
            return this.$store.getters['menu/weekStart'];
        },
        weekEnd() {
            return this.$store.getters['menu/weekEnd'];
        },
        weekOffset() {
            return this.$store.getters['menu/weekOffset'];
        },
        savedMenu() {
            return this.$store.getters['menu/savedMenu'];
        },
        today() {
            return this.$store.getters['menu/today'];
        },
        menu() {
            return this.$store.getters['menu/menu'];
        },
        day:{
            get(){
                if(this.savedMenu) {
                    return this.$store.getters['menu/day'];
                }
                else {
                    return []
                }
            },
            set(value){
                this.$store.dispatch('menu/updateDay',value);
            }
        },
        maxWeek() {
            if(this.weekOffset > 0) {
                return true
            } else {
                return false
            }
        },
        minWeek() {
            if(this.weekOffset < 0) {
                return true
            } else {
                return false
            }
        },
        weekDescription() {
            if(this.weekOffset == -1) {
                return 'Last Week'
            } else if(this.weekOffset == 0) {
                return 'This Week'
            } else if(this.weekOffset == 1) {
                return 'Next Week'
            } else {
                return null
            }
        }
    }
};
</script>
